export const BRAIN_COLOR_PALETTE = [
  { name: "Ocean Blue", value: "#3b82f6" },
  { name: "Forest Green", value: "#10b981" },
  { name: "Royal Purple", value: "#6366f1" },
  { name: "Sunset Orange", value: "#f59e0b" },
  { name: "Ruby Red", value: "#ef4444" },
  { name: "Emerald Teal", value: "#14b8a6" },
  { name: "Rose Pink", value: "#ec4899" },
  { name: "Violet", value: "#8b5cf6" },
  { name: "Slate Gray", value: "#64748b" },
  { name: "Amber Gold", value: "#d97706" },
  { name: "Cyan", value: "#06b6d4" },
  { name: "Lime Green", value: "#65a30d" },
  { name: "Indigo", value: "#4f46e5" },
  { name: "Copper", value: "#ea580c" },
  { name: "Sage", value: "#16a34a" },
  { name: "Plum", value: "#9333ea" },
] as const;

export const getNextAvailableColor = (usedColors: Array<string | undefined>): string => {
  const used = new Set((usedColors || []).filter(Boolean) as string[]);
  const available = BRAIN_COLOR_PALETTE.find(c => !used.has(c.value));
  return available?.value || BRAIN_COLOR_PALETTE[0].value;
};

export const getColorName = (value: string): string => {
  const found = BRAIN_COLOR_PALETTE.find(c => c.value.toLowerCase() === (value || '').toLowerCase());
  return found?.name || 'Custom';
};


